import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const InfoModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={onClose}
          />
          
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-xl p-6 max-w-md w-[90%] md:w-full max-h-[90vh] overflow-y-auto z-50"
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-teal-700">Sobre o Grupo FocoSeg</h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 focus:outline-none"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="mb-6">
              <p className="text-gray-700 mb-4">
                O Grupo FocoSeg é composto por três empresas especializadas que trabalham em conjunto para oferecer soluções completas em segurança e saúde ocupacional:
              </p>
              
              <div className="space-y-4">
                <div className="border-l-4 border-teal-500 pl-3 py-2">
                  <h3 className="font-bold text-teal-700">FocoSeg</h3>
                  <p className="text-gray-600">Especializada em medicina ocupacional e segurança do trabalho, oferecendo serviços de consultoria, exames e documentação.</p>
                </div>
                
                <div className="border-l-4 border-blue-500 pl-3 py-2">
                  <h3 className="font-bold text-blue-700">CapacitaSeg</h3>
                  <p className="text-gray-600">Centro de treinamentos e capacitação profissional com foco em segurança do trabalho e normas regulamentadoras.</p>
                  <a 
                    href="https://capacitaseg.com.br" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline inline-flex items-center mt-2"
                  >
                    Visitar site
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
                
                <div className="border-l-4 border-green-500 pl-3 py-2">
                  <h3 className="font-bold text-green-700">ExameSeg</h3>
                  <p className="text-gray-600">Clínica especializada em exames complementares e ocupacionais, com foco em agilidade e qualidade no atendimento.</p>
                  <a 
                    href="https://exameseg.com.br" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-600 hover:underline inline-flex items-center mt-2"
                  >
                    Visitar site
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            
            <div className="flex justify-end">
              <button
                onClick={onClose}
                className="px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
              >
                Fechar
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default InfoModal;